import React from 'react';
import { FaRobot, FaRegClock } from 'react-icons/fa';
import TestResults from './TestResults';

const MockTest = ({ 
  showMockTest,
  mockTestConfig,
  setMockTestConfig,
  startMockTest,
  timeLeft,
  currentTest,
  setCurrentTest,
  submitTest,
  testResults
}) => {
  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      {testResults ? (
        <TestResults testResults={testResults} currentTest={currentTest} />
      ) : !showMockTest ? (
        <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
          <div className="flex items-center space-x-3 mb-6">
            <FaRobot className="text-3xl text-indigo-600" />
            <h2 className="text-3xl font-bold text-gray-900">AI Mock Test</h2>
          </div>
          
          <div className="space-y-6">
            <div className="bg-gray-50 p-6 rounded-xl">
              <label className="block text-base font-semibold text-gray-800 mb-2">
                Select Test Type
              </label>
              <select
                className="w-full px-4 py-3 rounded-lg border border-gray-300 bg-white 
                          shadow-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 
                          transition-all duration-200 text-gray-700"
                value={mockTestConfig.type}
                onChange={(e) => setMockTestConfig((prev) => ({ ...prev, type: e.target.value }))}
              >
                <option value="">Choose Type</option>
                <option value="technical">Technical Assessment</option>
                <option value="aptitude">Aptitude Test</option>
                <option value="personality">Personality Evaluation</option>
              </select>
            </div>

            <div className="bg-gray-50 p-6 rounded-xl">
              <label className="block text-base font-semibold text-gray-800 mb-2">
                Select Subject
              </label>
              <select
                className="w-full px-4 py-3 rounded-lg border border-gray-300 bg-white 
                          shadow-sm focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 
                          transition-all duration-200 text-gray-700"
                value={mockTestConfig.subject}
                onChange={(e) => setMockTestConfig((prev) => ({ ...prev, subject: e.target.value }))}
              >
                <option value="">Choose Subject</option>
                <option value="javascript">JavaScript Development</option>
                <option value="python">Python Programming</option>
                <option value="java">Java Development</option>
                <option value="general">General Aptitude</option>
              </select>
            </div>

            <div className="mt-8">
              <button
                onClick={startMockTest}
                disabled={!mockTestConfig.type || !mockTestConfig.subject}
                className="w-full bg-indigo-600 text-white py-4 px-6 rounded-xl
                          font-semibold text-lg shadow-lg hover:bg-indigo-700 
                          transform hover:scale-[1.02] transition-all duration-200
                          disabled:opacity-50 disabled:cursor-not-allowed
                          disabled:hover:scale-100 flex items-center justify-center"
              >
                <FaRegClock className="mr-2" />
                Start Assessment
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-900">Mock Test in Progress</h2>
              <p className="text-gray-600 mt-2">
                {mockTestConfig.type} - {mockTestConfig.subject}
              </p>
            </div>
            <div className="bg-indigo-100 px-6 py-3 rounded-full">
              <div className="text-xl font-bold text-indigo-600 flex items-center">
                <FaRegClock className="mr-2" />
                {Math.floor(timeLeft / 60)}:{(timeLeft % 60).toString().padStart(2, '0')}
              </div>
            </div>
          </div>
          
          {currentTest && (
            <div className="space-y-8">
              {currentTest.questions.map((question, index) => (
                <div key={index} className="bg-gray-50 p-6 rounded-xl">
                  <p className="text-lg font-medium text-gray-900 mb-4">
                    {index + 1}. {question.text}
                  </p>
                  <div className="space-y-3">
                    {question.options.map((option, optIndex) => (
                      <label
                        key={optIndex}
                        className="flex items-center p-4 bg-white rounded-lg border
                                 border-gray-200 cursor-pointer hover:bg-indigo-50
                                 transition-all duration-200"
                      >
                        <input
                          type="radio"
                          name={`question-${index}`}
                          value={optIndex}
                          checked={currentTest.answers[index] === optIndex}
                          onChange={() => {
                            const newAnswers = [...currentTest.answers];
                            newAnswers[index] = optIndex;
                            setCurrentTest(prev => ({ ...prev, answers: newAnswers }));
                          }}
                          className="w-4 h-4 text-indigo-600 border-gray-300 focus:ring-indigo-500"
                        />
                        <span className="ml-3 text-gray-700">{option}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))}
              
              <button
                onClick={submitTest}
                className="w-full bg-green-600 text-white py-4 px-6 rounded-xl
                          font-semibold text-lg shadow-lg hover:bg-green-700 
                          transform hover:scale-[1.02] transition-all duration-200
                          flex items-center justify-center mt-8"
              >
                Submit Test
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MockTest;